/* PLAB-05 (#78). Was two inline <script> blocks in snippets/c-variant-picker.liquid: a swatch
   debug table, since removed (see below), and the per-size badge-name length limits. The snippet
   renders twice on a product page, so both blocks ran twice; the loader is emitted twice as well
   and the browser serves the second tag from cache, which keeps that behaviour exactly. A sibling
   of component-variant-picker.js, which is a minified browserify bundle with no source here. */

/* GAP6-13 (#245). A swatch debug block used to run here on DOMContentLoaded: it built a table of
   every colour label's text, data-swatch and --swatch value and printed it with console.table,
   on every product page, for every customer. It was a developer aid that shipped.

   It also carried the one reachable source in this theme of "Failed to execute 'getComputedStyle'
   on 'Window': parameter 1 is not of type 'Element'". Two of its three lookups used `?.`; the
   third passed querySelector's result straight into getComputedStyle, so a colour label rendered
   without a swatch threw. Its own try/catch turned that into a console.warn and silently dropped
   the whole table — so the block failed quietly at exactly the moment it was wanted.

   Removed rather than guarded. The monitor's matching suppression is gone with it, so if that
   error appears again it will be reported instead of filtered. */
  (() => {
    /* I18N-06 (#163): visible strings come from the page; the English literal is the fallback. */
    const wfStrings = (() => {
      try {
        const node = document.querySelector('script[type="application/json"][data-wf-i18n="variant-picker"]');
        const parsed = node ? JSON.parse(node.textContent) : null;
        return parsed && typeof parsed === 'object' ? parsed : {};
      } catch (error) {
        return {};
      }
    })();
    // Shopify's `t` HTML-escapes every translation whose key does not end in `_html` (French
    // "n'a" arrives as "n&#39;a"), so the page's values are decoded back to plain text.
    const wfDecode = (text) =>
      text.replace(/&(#x[0-9a-f]+|#\d+|amp|lt|gt|quot|apos);/gi, (entity, body) => {
        const named = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'" }[body.toLowerCase()];
        if (named) return named;
        const code = body[1] === 'x' || body[1] === 'X' ? parseInt(body.slice(2), 16) : parseInt(body.slice(1), 10);
        return code > 0 && code <= 0x10ffff ? String.fromCodePoint(code) : entity;
      });
    const tr = (key, fallback, values = {}) => {
      const text = typeof wfStrings[key] === 'string' && wfStrings[key] !== '' ? wfDecode(wfStrings[key]) : fallback;
      return Object.keys(values).reduce((out, name) => out.split(`{${name}}`).join(values[name]), text);
    };

    const normalizeSize = (value) => {
      const size = String(value || '').trim().toLowerCase();

      if (size.includes('small')) return 'small';
      if (size.includes('medium')) return 'medium';
      if (size.includes('large')) return 'large';

      return 'small';
    };

    const initBadgeNameLimits = () => {
      document.querySelectorAll('.c-variant-picker').forEach((picker) => {
        const input = picker.querySelector('[data-badge-name-input]');
        const limitText = picker.querySelector('[data-badge-name-limit]');
        const sizeRadios = picker.querySelectorAll('.c-variant-picker__item--size input[type="radio"]');

        if (!input || !sizeRadios.length || input.dataset.sizeLimitReady === 'true') return;

        input.dataset.sizeLimitReady = 'true';

        const limits = JSON.parse(input.dataset.sizeLimits || '{"small":6,"medium":7,"large":8}');

        const updateLimit = () => {
          const selectedSizeRadio = picker.querySelector('.c-variant-picker__item--size input[type="radio"]:checked');
          const selectedSizeText = selectedSizeRadio?.closest('.c-variant-picker__item')?.querySelector('.c-variant-picker__text')?.textContent?.trim();
          const selectedSize = normalizeSize(selectedSizeText);
          const maxLength = limits[selectedSize] || 6;

          input.maxLength = maxLength;

          if (input.value.length > maxLength) {
            input.value = input.value.slice(0, maxLength);
            input.dispatchEvent(new Event('input'));
          }

          if (limitText) {
            /* I18N-06 (#163): the sentence and the fallback size name come from the snippet's bridge. */
            limitText.textContent = tr('badge_name_limit', '{size} allows up to {max} characters.', {
              size: selectedSizeText || tr('selected_size', 'Selected size'),
              max: maxLength,
            });
          }
        };

        sizeRadios.forEach((radio) => {
          radio.addEventListener('change', updateLimit);
        });

        updateLimit();
      });
    };

    document.addEventListener('DOMContentLoaded', initBadgeNameLimits);
    document.addEventListener('shopify:section:load', initBadgeNameLimits);
  })();
